import React, { useEffect, useState } from 'react';
import AuthRegister from './AuthRegister';
import AuthLogin from './AuthLogin';
import { fetchApi } from '../services/api';

const AuthGate: React.FC = () => {
  const [registrationAllowed, setRegistrationAllowed] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Use the new GET endpoint to check if registration is allowed
    const checkRegistration = async () => {
      setLoading(true);
      try {
        const res = await fetchApi<{ allowed: boolean }>('/auth/register/allowed');
        setRegistrationAllowed(res.allowed);
      } catch (err: any) {
        // If the check fails, default to login only
        setRegistrationAllowed(false);
      } finally {
        setLoading(false);
      }
    };
    checkRegistration();
  }, []);

  if (loading) return null;
  if (registrationAllowed) return <AuthRegister />;
  return <AuthLogin />;
};

export default AuthGate; 